<template>
  <div class="showDetail" v-if="reqDetail|| recordedIn || personData" v-loading="loading" ref="showDetail" :style="detailStyle" @mousedown="moveDown">
    <div @mousedown.stop="">
      <div class="showDetail-header">
        <div class="showDetail-header-left">
          <template v-if="reqDetail|| recordedIn">
            <el-tabs v-model="current" @tab-click="getPersonDetail" v-if="personList.length > 1">
              <el-tab-pane v-for="(row, index) in personList" :key="index" :label="row.Name" :name="row.Id"></el-tab-pane>
            </el-tabs>
            <div class="showDetail-title" v-else-if="reqDetail">
              <span>{{ reqDetail.Name }}</span>
            </div>
            <div class="showDetail-title" v-else-if="recordedIn">
              <span>{{ recordedIn.Name }}</span>
            </div>
          </template>
        </div>
        <i class="el-icon-close" @click.stop="close"></i>
      </div>
      <template v-if="reqDetail || recordedIn">
        <template v-if="recordedIn">
          <!-- <div class="showDetail-row">{{ $i18n.$t('人物名称：') }}{{ recordedIn.PersonName }}</div> -->
          <div class="showDetail-row">{{ $i18n.$t('分类：') }}{{ recordedIn.Category }}</div>
          <div class="showDetail-row">{{ $i18n.$t('目录：') }}{{ recordedIn.Catalog }}</div>
          <div class="showDetail-row">{{ $i18n.$t('原文：') }}<span v-html="recordedIn.OriginalText.replace(/\n/g, '<br />')"></span></div>
          <div class="showDetail-row">{{ $i18n.$t('译文：') }}<span v-html="recordedIn.VernacularText.replace(/\n/g, '<br />')"></span></div>
        </template>
        <template v-else>
          <template v-if="reqDetail.labels === 'Address'">
            <div class="showDetail-row">{{ $i18n.$t('别称：') }}{{ reqDetail.Alias.join(',') }}</div>
            <div class="showDetail-row">{{ $i18n.$t('类别：') }}{{ reqDetail.labels | label }}</div>
            <!-- <div class="showDetail-row">{{ $i18n.$t('行政区：') }}中国-河北-保定市-涿州县</div> -->
            <div class="showDetail-row">{{ $i18n.$t('经纬度：') }}{{ reqDetail.Longitude }},{{ reqDetail.Latitude }}</div>
            <!-- <div class="showDetail-row">{{ $i18n.$t('朝代：') }}朝代：唐</div>
            <div class="showDetail-row">{{ $i18n.$t('属地：') }}河北道</div>
            <div class="showDetail-row">{{ $i18n.$t('备注：') }}（618 ~ 907）縣級行政中心所在地</div> -->
            <div class="showDetail-row">{{ $i18n.$t('注解：') }}{{ reqDetail.Introduction }}</div>
          </template>
          <template v-if="reqDetail.labels === 'Person'">
            <div class="showDetail-row" v-if="!nativePlaceDetails.length">
              {{ $i18n.$t('籍贯地：') }}{{ (reqDetail.native_place || []).join('，') || $i18n.$t('未详') }}
            </div>
            <template v-if="nativePlaceDetails.length">
              <div class="showDetail-row-title">{{ $i18n.$t('籍贯地') }}</div>
              <div v-for="(place, idx) in nativePlaceDetails" :key="idx" class="native-place-block">
                <div class="showDetail-row-title">{{ place.Name }}</div>
                <div class="showDetail-row" v-if="place.Alias && place.Alias.length">
                  {{ $i18n.$t('别称：') }}{{ Array.isArray(place.Alias) ? place.Alias.join('，') : place.Alias }}
                </div>
                <div class="showDetail-row">
                  {{ $i18n.$t('经纬度：') }}{{ place.Longitude }},{{ place.Latitude }}
                </div>
                <div class="showDetail-row" v-if="place.Introduction">
                  {{ $i18n.$t('注解：') }}{{ place.Introduction }}
                </div>
              </div>
            </template>
          </template>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import { addressDetail, namePerson } from '@/api/place'
import { personDetail } from '@/api/home'
import { i18n } from '@/i18n'
export default {
  name: 'mapShowDetail',
  props: {
    detail: {
      type: Object,
      default: null
    },
    recordedIn: {
      type: Object,
      default: null
    },
    personData: {
      type: Object,
      default: null
    },
    nativePlaceList: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    label (l) {
      if (!l) return l
      const labels = {
        Person: i18n.$t('人物'),
        Biographie: i18n.$t('传记'),
        Address: i18n.$t('地点')
      }
      return labels[l]
    }
  },
  watch: {
    detail: {
      deep: true,
      handler (v) {
        if (v) {
          this.getDetail()
        } else {
          this.reqDetail = null
        }
      }
    },
    personData: {
      deep: true,
      handler (v) {
        if (v) {
          this.getDetail()
        } else {
          this.reqDetail = null
          this.current = ''
          this.personList = []
          this.nativePlaceDetails = []
        }
      }
    },
    nativePlaceList () {
      if (this.reqDetail && this.reqDetail.labels === 'Person') {
        this.fetchNativePlaceDetails(this.reqDetail)
      }
    }
  },
  data () {
    return {
      activeName: i18n.$t('扩展介绍'),
      tabList: [
        { name: i18n.$t('扩展介绍'), key: 'ExtendedIntroduction' },
        { name: i18n.$t('记载于'), key: 'RecordedInfo' },
        // { name: '著作列表', key: 'Works' },
        // { name: '研究文献', key: 'ResearchLiterature' },
        { name: i18n.$t('原文'), key: 'OriginalText' },
        { name: i18n.$t('白话文'), key: 'VernacularText' }
      ],
      reqDetail: null,
      loading: false,
      current: '',
      personList: [],
      nativePlaceDetails: [],
      detailStyle: {
        position: '',
        left: '',
        top: ''
      },
      detailPosition: {
        pageX: 0,
        pageY: 0,
        x: 0,
        y: 0
      }
    }
  },
  methods: {
    move (e) {
      const { pageX, pageY } = e
      this.detailStyle = {
        position: 'fixed',
        left: `${pageX - this.detailPosition.x}px`,
        top: `${pageY - this.detailPosition.y}px`
      }
    },
    moveDown (e) {
      const { pageX, pageY } = e
      const { left, top } = this.$refs.showDetail.getBoundingClientRect()
      this.detailPosition = {
        pageX,
        pageY,
        x: pageX - left,
        y: pageY - top
      }
      this.detailStyle = {
        position: 'fixed',
        left: `${left}px`,
        top: `${top}px`
      }
      window.addEventListener('mousemove', this.move)
      window.addEventListener('mouseup', this.moveUp)
    },
    moveUp (e) {
      window.removeEventListener('mousemove', this.move)
      window.removeEventListener('mouseup', this.moveUp)
    },
    getPersonDetail (row) {
      if (row && row.name) {
        this.$emit('tab-change', row.name)
      }
      this.loading = true
      this.nativePlaceDetails = []
      personDetail({
        Id: this.current
      }).then(res => {
        this.reqDetail = res.data
        this.fetchNativePlaceDetails(res.data)
      }).finally(() => {
        this.loading = false
      })
    },
    fetchNativePlaceDetails (personData) {
      if (!this.nativePlaceList.length || !personData) {
        this.nativePlaceDetails = []
        return
      }
      const nativePlaceNames = personData.native_place || []
      if (!nativePlaceNames.length) {
        this.nativePlaceDetails = []
        return
      }
      const matched = this.nativePlaceList.filter(place =>
        nativePlaceNames.includes(place.Name)
      )
      if (!matched.length) {
        this.nativePlaceDetails = []
        return
      }
      Promise.all(
        matched.map(place =>
          addressDetail({ Id: place.Id }).then(res => res.data).catch(() => null)
        )
      ).then(details => {
        this.nativePlaceDetails = details.filter(Boolean)
      })
    },
    getDetail () {
      if (this.recordedIn) return false
      this.loading = true
      if (this.personData) {
        namePerson({
          name: this.personData.name
        }).then(res => {
          this.personList = res.data
          if (this.personList[0]) {
            this.current = this.personList[0].Id
            this.getPersonDetail()
          }
        }).catch(() => {
          this.loading = false
        })
        return false
      }
      addressDetail({
        Id: this.detail.Id
      }).then(res => {
        this.reqDetail = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-tabs__item {
  font-size: 20px;
}
.showDetail {
  position: absolute;
  right: 30px;
  top: 30px;
  background-color: #ffffff;
  padding: 30px;
  box-sizing: border-box;
  width: 600px;
  max-height: 640px;
  border-radius: 10px;
  box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.10);
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 9999;
  &-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-left {
      width: calc(100% - 40px);
    }
    i {
      font-size: 24px;
      font-weight: 700;
      text-align: left;
      color: #333333;
      cursor: pointer;
    }
  }
  &-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 26px;
    font-weight: 700;
    text-align: left;
    color: #333333;
  }
  &-row {
    font-size: 20px;
    font-weight: 400;
    text-align: left;
    color: #333333;
    margin-top: 20px;
    &-title {
      font-size: 20px;
      font-weight: 500;
      text-align: left;
      color: #987443;
      padding-left: 8px;
      box-sizing: border-box;
      position: relative;
      margin-top: 20px;
      &::before {
        content: "";
        width: 2px;
        height: 16px;
        background: #987443;
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -8px;
      }
    }
    &-flex {
      display: flex;
      flex-wrap: wrap;
      &-item {
        font-size: 18px;
        font-weight: 400;
        text-align: left;
        color: #333333;
        padding-right: 30px;
        border-right: 1px solid #e2dacf;
        margin-right: 30px;
        box-sizing: border-box;
        margin-top: 20px;
        &:last-child {
          border-right: none;
          margin-right: 0;
          padding-right: 0;
        }
      }
    }
    &-tab {
      margin-top: 20px;
    }
  }
}
.native-place-block {
  margin-top: 16px;
  padding: 16px;
  background: #faf8f5;
  border-radius: 8px;
  .showDetail-row {
    margin-top: 10px;
  }
  .showDetail-row-title {
    margin-top: 0;
  }
}
</style>
